<p-toast></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
<p-confirmDialog key="confirm-bad-supplier" header="Confirmation" icon="pi pi-exclamation-triangle">
	<ng-template pTemplate="message" let-message>
		<div class="flex flex-column gap-2 ml-4">
			<p>{{message.message}}</p>
			<div class="flex flex-column gap-2">
				<label for="raison">Raison</label>
				<input type="text" pInputText [(ngModel)]="bonCommande.raisonFournisseur">
			</div>
		</div>
	</ng-template>
</p-confirmDialog>
<p-card *ngIf="!EstCharge()">
	<div class="fluid formgrid grid">
		<div class="flex flex-column gap-2 my-2 col-12 text-center">
			<p-progressSpinner></p-progressSpinner>
		</div>
	</div>
</p-card>

<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<h5>Bon de commande #{{bonCommande.numero}} ({{bonCommande.typeBonCommande}})
				<span *ngIf="bonCommande.indPrive" class="inline-flex align-items-center gap-1 text-color-secondary ml-2"
					pTooltip="Visible uniquement par son créateur" tooltipPosition="top">
					<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
						fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
						stroke-linejoin="round" aria-hidden="true">
						<path d="M14 18a2 2 0 0 0-4 0" />
						<path d="m19 11-2.11-6.657a2 2 0 0 0-2.752-1.148l-1.276.61A2 2 0 0 1 12 4H8.5a2 2 0 0 0-1.925 1.456L5 11" />
						<path d="M2 11h20" />
						<circle cx="17" cy="18" r="3" />
						<circle cx="7" cy="18" r="3" />
					</svg>
					<span class="text-sm font-medium">Privé</span>
				</span>
				<span [class]="'statut ' + bonCommande.statut.nom.toLowerCase().replace(' ','')">
					{{bonCommande.statut.nom}}
				</span>
				<span *ngIf="modeApercu"> 
					<i class="pi pi-id-card ml-4" ></i>
					<a class="lienFicheComplete" (click)="ouvrirFicheComplete()">Aller à la fiche complète</a>
				</span>
			</h5>
			<h6 *ngIf="bonCommande.dateEnvoi"><i class="pi pi-send" style="font-size: 0.8rem"></i> Envoyé le :
				{{bonCommande.dateEnvoi | date:'yyyy-MM-dd HH:mm:ss'}}</h6>

			<p-menubar [model]="menu" *ngIf="!modeApercu">
				<ng-template pTemplate="end">
					<div class="flex align-items-center gap-2">
						@if (syncCtrlPlanifiee) {
							<span class="inline-flex align-items-center gap-1 text-color-secondary text-sm cursor-help"
								pTooltip="La synchronisation CTRL sera lancée environ une minute après la dernière modification."
								tooltipPosition="bottom">
								<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
									fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
									stroke-linejoin="round" aria-hidden="true">
									<path d="M12 3a9.75 9.75 0 0 1 6.74 2.74" />
									<path d="M18.74 5.74 21 8" />
									<path d="M21 8V3" />
									<path d="M7.5 19.794c-6-3.464-6-12.124 0-15.588" />
									<path d="M7.5 4.206A9 9 0 0 1 12 3" />
									<path d="M12 7v5l4 2" />
									<path d="M14 20.775A9 9 0 0 1 12 21" />
									<path d="M19 17.656a9 9 0 0 1-1.5 1.456" />
									<path d="M21 12a9 9 0 0 1-.228 2" />
									<path d="M21 8h-5" />
								</svg>
								<span>Synchronisation CTRL sous peu…</span>
							</span>
						}
						<p-tag
							[severity]="peutModifierContenu ? 'success' : 'secondary'"
							[icon]="peutModifierContenu ? 'pi pi-pencil' : 'pi pi-lock'"
							[value]="peutModifierContenu ? 'Modifiable' : 'Non modifiable'"
							styleClass="text-sm cursor-help white-space-nowrap"
							[pTooltip]="obtenirTooltipStatutEdition()"
							tooltipPosition="bottom"
							[fitContent]="true" />
					</div>
				</ng-template>
			</p-menubar>

		</p-card>
	</div>
</div>


<div *ngIf="EstCharge()" class="grid">
	<div class="col-12">
		<p-card>
			<p-tabView [scrollable]="true" orientation="left">
				<p-tabPanel header="Informations générales" leftIcon="pi pi-info-circle">
					@if (!peutModifierContenu && !modeApercu) {
						<p-message
							severity="warn"
							styleClass="w-full mb-3"
							[text]="obtenirTooltipStatutEdition()" />
					}
					<div class="fluid formgrid grid">

						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="firstname">Numéro</label>
							<span class="champConsultation">{{bonCommande.numero}}</span>
						</div>
                        <div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
                            <label for="revisionBdc">Révision</label>
							<app-inline-editable-field
								[value]="bonCommande.revision"
								type="text"
								[readonly]="!peutModifierContenu"
								(save)="sauvegarderChamp('revision', $event)">
							</app-inline-editable-field>
                        </div>
						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="dateBdc">Date@if (peutModifierContenu) {<span class="requis">*</span>}</label>
							<app-inline-editable-field
								[value]="bonCommande.dateAchat"
								type="date"
								[readonly]="!peutModifierContenu"
								(save)="sauvegarderChamp('dateachat', $event)">
							</app-inline-editable-field>
						</div>
						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="projet">Projet@if (peutModifierContenu) {<span class="requis">*</span>}</label>
							<app-inline-editable-field
								[value]="bonCommande.projet"
								type="select"
								[readonly]="!peutModifierContenu"
								[options]="listeCodeProjet"
								optionLabel="nom"
								dataKey="codeProjetId"
								[filter]="true"
								filterBy="code,nom"
								placeholder="Sélectionner un code de projet..."
								[displayFn]="afficherProjet"
								(save)="surSauvegardeProjet($event)">
								<ng-template let-code pTemplate="item">
									<div>{{code.code}} - {{code.nom}}</div>
								</ng-template>
							</app-inline-editable-field>
						</div>
						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="lastname">Fournisseur@if (peutModifierContenu) {<span class="requis">*</span>}</label>
							<app-inline-editable-field
								[value]="bonCommande.fournisseur"
								type="select"
								[readonly]="!peutModifierContenu"
								[options]="fournisseurs"
								optionLabel="nom"
								dataKey="fournisseurId"
								[filter]="true"
								filterBy="numero,nom"
								[virtualScroll]="true"
								[virtualScrollItemSize]="38"
								placeholder="Sélectionner un fournisseur..."
								[displayFn]="afficherFournisseur"
								(save)="surSauvegardeFournisseur($event)">
								<ng-template let-fournisseur pTemplate="item">
									<div class="flex align-items-center gap-2">
										<p-tag [severity]="fournisseurService.getQualityScore(fournisseur)"
											[value]="fournisseurService.getQualityScoreLabel(fournisseur)">
										</p-tag>
										<div>{{fournisseur?.nom}} ({{fournisseur?.numero}})</div>
									</div>
								</ng-template>
							</app-inline-editable-field>
							@if (bonCommande.raisonFournisseur) {
								<small>{{bonCommande.raisonFournisseur}}</small>
							}
						</div>

						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="employe">Employé</label>
							<span class="champConsultation"><app-employe-avec-emplacement [employe]="bonCommande.employe"></app-employe-avec-emplacement></span>
						</div>

						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="lastname">Fréquence</label>
							<app-inline-editable-field
								[value]="selectionFrequence"
								type="select"
								[readonly]="!peutModifierContenu"
								[options]="frequences"
								optionLabel="valeur"
								dataKey="cle"
								[displayFn]="afficherFrequence"
								placeholder="Sélectionner une fréquence..."
								(save)="surSauvegardeFrequence($event)">
							</app-inline-editable-field>
						</div>
						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="lastname">Adresse de livraison@if (peutModifierContenu) {<span class="requis">*</span>}</label>
							<app-inline-editable-field
								[value]="bonCommande.adresse"
								[readonly]="!peutModifierContenu"
								[displayFn]="afficherAdresseLivraison"
								placeholder="Sélectionner une adresse…"
								(save)="surChangementAdresseLivraison($event)">
								<ng-template #editor let-commit="commit">
									<app-selection-adresse-emplacement
										[ngModel]="bonCommande.adresse"
										[emplacementId]="bonCommande.emplacement?.emplacementId"
										(ngModelChange)="commit($event)"
										(emplacementIdChange)="surChangementEmplacementLivraison($event)">
									</app-selection-adresse-emplacement>
								</ng-template>
							</app-inline-editable-field>
						</div>
						<div class="sihc-field flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-4">
							<label for="lastname">Requis le</label>
							<app-inline-editable-field
								[value]="bonCommande.requisLe"
								type="date"
								[readonly]="!peutModifierContenu"
								(save)="sauvegarderChamp('requisle', $event)">
							</app-inline-editable-field>
						</div>
					</div>
		
					<div class="fluid formgrid grid mb-4 mt-2">
						<div class="sihc-field flex flex-column gap-2 my-2 col-12">
							<label for="note">Note</label>
							<app-inline-editable-field
								[value]="bonCommande.note"
								type="textarea"
								[readonly]="!peutModifierContenu"
								(save)="sauvegarderChamp('note', $event ?? '')">
							</app-inline-editable-field>
						</div>
					</div>
					<!-- <div class="fluid formgrid grid">
						<div class="flex flex-column gap-2 my-2 col-12">
							<label for="conditions">Conditions</label>
							<input #champNote [readonly]="modeConsultation()" type="text" pInputText id="conditions"
								[(ngModel)]="bonCommande.conditions" autocomplete="off" />
						</div>
					</div> -->
					 <div class="flex align-content-center justify-content-between mb-2">
						<div class="flex align-items-center gap-4 flex-wrap">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input pInputText type="text"
									(input)="dt.filterGlobal($event.target.value, 'contains')"
									placeholder="Recherche..." />
							</span>
							@if (peutModifierContenu) {
								<button pButton pRipple icon="pi pi-plus"
									class="p-button-success" pTooltip="Ajouter un item" pTooltipPosition="left"
									(click)="modifierOuAjouterItem()"></button>
							}
						</div>
						<div>
							<p-multiSelect [options]="cols" [(ngModel)]="selectedColumns" optionLabel="header"
								selectedItemsLabel="{0} colonnes sélectionnés" [style]="{minWidth: '200px'}"
								placeholder="Colonnes..."></p-multiSelect>
						</div>
					</div>
					<p-table #dt [value]="bonCommande.itemsBonCommande" [columns]="selectedColumns"
						dataKey="itemBonCommandeId" tableStyleClass="tableNormale" autoLayout="true"
						[(selection)]="selectionMultipleEntree" (onRowSelect)="surChangementSelection()"
						(onRowUnselect)="surChangementSelection()" (onHeaderCheckboxToggle)="surChangementSelection()"
						 [rowHover]="true" [filterDelay]="0" [scrollable]="true"
						[globalFilterFields]="['item.numero','item.description','noFournisseur']">
						<ng-template pTemplate="header" let-columns>
							<tr>
								<th style="min-width: 3rem">
									@if (peutModifierContenu) {
										<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
									}
								</th>
								<th pSortableColumn="numero">
									<div class="flex justify-content-between align-items-center">
										No SIHC
										<p-sortIcon field="numero"></p-sortIcon>
										<p-columnFilter type="text" field="numero" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="description">
									<div class="flex justify-content-between align-items-center">
										Description
										<p-sortIcon field="description"></p-sortIcon>
										<p-columnFilter type="text" field="description" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="statut.nom">
									<div class="flex justify-content-between align-items-center">
										Statut
										<p-sortIcon field="statut.nom"></p-sortIcon>
										<p-columnFilter type="text" field="statut.nom" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="noFournisseur">
									<div class="flex justify-content-between align-items-center">
										No pièce fournisseur
										<p-sortIcon field="noFournisseur"></p-sortIcon>
										<p-columnFilter type="text" field="noFournisseur" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="quantite">
									<div class="flex justify-content-between align-items-center">
										Quantité
										<p-sortIcon field="quantite"></p-sortIcon>
										<p-columnFilter type="text" field="quantite" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="unite.code">
									<div class="flex justify-content-between align-items-center">
										Unité
										<p-sortIcon field="unite.code"></p-sortIcon>
										<p-columnFilter type="text" field="unite.code" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="prix">
									<div class="flex justify-content-between align-items-center">
										Prix
										<p-sortIcon field="prix"></p-sortIcon>
										<p-columnFilter type="text" field="prix" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<th pSortableColumn="codeExtra.code">
									<div class="flex justify-content-between align-items-center">
										Extra
										<p-sortIcon field="codeExtra.code"></p-sortIcon>
										<p-columnFilter type="text" field="codeExtra.code" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<th pSortableColumn="codeProjet">
									<div class="flex justify-content-between align-items-center">
										Projet
										<p-sortIcon field="codeProjet"></p-sortIcon>
										<p-columnFilter type="text" field="codeProjet" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="codeActivite">
									<div class="flex justify-content-between align-items-center">
										Code d'activité
										<p-sortIcon field="codeActivite"></p-sortIcon>
										<p-columnFilter type="text" field="codeActivite" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="codeEquipement">
									<div class="flex justify-content-between align-items-center">
										Code d'équipement
										<p-sortIcon field="codeEquipement"></p-sortIcon>
										<p-columnFilter type="text" field="codeEquipement" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>
								<th pSortableColumn="emplacement.nom">
									<div class="flex justify-content-between align-items-center">
									  Emplacement
										<p-sortIcon field="emplacement.nom"></p-sortIcon>
										<p-columnFilter type="text" field="emplacement.nom" display="menu"
											class="ml-auto">
										</p-columnFilter>
									</div>
								</th>

								<!-- <th pSortableColumn="col.flex flex-column gap-2 my-2" *ngFor="let col of columns">
									<div class="flex justify-content-between align-items-center">
										{{col.header}}
										<p-sortIcon field="col.flex flex-column gap-2 my-2"></p-sortIcon>
										<p-columnFilter type="text" field="col.flex flex-column gap-2 my-2" display="menu" class="ml-auto">
										</p-columnFilter>
									</div>
								</th> -->
								<th style="min-width: 10rem;" pFrozenColumn alignFrozen="right">Actions</th>

							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-entree let-columns="columns">
							<tr>
								<td>
									@if (peutModifierContenu && !estLigneComplete(entree)) {
										<p-tableCheckbox [value]="entree"></p-tableCheckbox>
									}
								</td>
								<td>{{entree.item.numero}}</td>
								<td>{{entree.item.description}}</td>
								<td>
									@if (entree.statut?.nom) {
										<span [class]="'statut ' + entree.statut.nom.toLowerCase().replace(' ','')">{{entree.statut.nom}}</span>
									}
								</td>
								<td>{{entree.noFournisseur}}</td>
								<td>{{entree.quantite}}</td>
								<td>{{entree.uniteQte}}</td>
								<td>{{entree.prix | currency:'CAD':'symbol-narrow':'1.4'}}</td>
								<td>{{entree.codeExtra?.code}}</td>
								<td>{{entree.codeProjet?.code}}</td>
								<td>{{entree.codeActivite?.code}}</td>
								<td>{{entree.codeEquipement?.code}}</td>
								<td>{{entree.emplacement | nomEmplacement}}</td>
								<!-- <td *ngFor="let col of columns">
									{{entree[col.flex flex-column gap-2 my-2]}}
								</td> -->
								<td pFrozenColumn alignFrozen="right">
									<div class="flex flex-wrap gap-1">
										@if (estAutorise('item_detail')) {
											<p-button pRipple text icon="pi pi-eye"
											severity="success"
											(click)="routerService.navigateByUrl('item/' + entree.item.itemId)"
											pTooltip="Voir l'item d'inventaire" pTooltipPosition="left"></p-button>
										}
										@if (peutModifierContenu && !estLigneComplete(entree)) {
											<p-button pRipple text icon="pi pi-pencil"
											severity="secondary"
											(click)="modifierOuAjouterItem(entree)"
											pTooltip="Modifier l'item" pTooltipPosition="left"></p-button>
											<p-button pRipple text icon="pi pi-trash"
											severity="danger"
											(click)="supprimerItems([entree])"
											pTooltip="Supprimer l'item" pTooltipPosition="left"></p-button>
										}
									</div>
								</td>

							</tr>
						</ng-template>
						<ng-template pTemplate="emptymessage">
							<tr>
								<td colspan="8">Aucun item.</td>
							</tr>
						</ng-template>
					</p-table>

					<div style="font-weight: 700; margin-top: 10px; text-align: right;">
						Prix total : {{prixTotal | currency}}
					</div>

					<!-- ##########   DIALOGUE DÉTAIL ENTRÉÉ BDC   ########## -->

					<p-dialog [(visible)]="productDialog" [style]="{width: '85%'}" header="Détail de l'item"
						[modal]="true" styleClass="fluid formgrid grid">
						<ng-template pTemplate="content">
							<div class="formgrid grid">
								<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
									<p-selectButton [options]="typesSaisie" [(ngModel)]="selectionTypeSaisie"
										optionLabel="valeur"></p-selectButton>
								</div>

							</div>
							<div class="formgrid grid">
								<div *ngIf="typeSaisieInventaire()" class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
									<label for="noSIHC">No SIHC</label>
									<input type="text" pInputText id="noSIHC" [(ngModel)]="product.item.numero" required
										readonly disabled autocomplete="off" autofocus />
									<small class="p-error" *ngIf="submitted && !product.item.numero">Le numéro SIHC est
										obligatoire.</small>
								</div>
								<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-6">
									<label for="description">Description</label>
									<input #descriptionItem type="text" pInputText id="description"
										[(ngModel)]="product.item.description" [readonly]="typeSaisieInventaire()"
										[disabled]="typeSaisieInventaire()" autocomplete="off" autofocus />
									<small class="p-error" *ngIf="submitted && !product.item.description">La description
										est
										obligatoire.</small>
								</div>
								<div *ngIf="typeSaisieInventaire()" class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
									<button pButton pRipple icon="pi pi-search"
										class="p-button-rounded p-button-primary mr-2 mt-3"
										(click)="RechercherItem()"></button>
								</div>
							</div>
							<div class="formgrid grid">
								<!-- 	<div class="flex flex-column gap-2 my-2">
								<label for="description">Description</label>
								<textarea id="description" pInputTextarea [(ngModel)]="product.description" required rows="3" cols="20"></textarea>
							</div>
							<div class="flex flex-column gap-2 my-2">
								<label for="inventoryStatus">Inventory Status</label>
								<p-dropdown [(ngModel)]="product.inventoryStatus" inputId="inventoryStatus" [options]="statuses" placeholder="Select">
									<ng-template let-option pTemplate="item">
										<span [class]="'product-badge status-' + option.value">{{option.label}}</span>
									</ng-template>
								</p-dropdown>
							</div> -->
								<div class="flex flex-column gap-2 my-2 col-12 md:col-6 lg:col-3">
									<label for="noFournisseur">No pièce fournisseur</label>
									<p-inputNumber id="noFournisseur" [(ngModel)]="product.noFournisseur">
									</p-inputNumber>
								</div>

							</div>
							<div class="formgrid grid">
								<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
									<label for="quantity">Quantite</label>
									<p-inputNumber id="quantity" [(ngModel)]="product.quantite"></p-inputNumber>
								</div>
								<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
									<label for="price">Prix</label>
									<p-inputNumber id="price" [(ngModel)]="product.prix" mode="currency" currency="USD"
										locale="en-US"></p-inputNumber>
								</div>
								<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
									<label for="quantity">No de projet</label>
									<p-inputNumber id="quantity" [(ngModel)]="product.noProjet"></p-inputNumber>
								</div>
								<div class="flex flex-column gap-2 my-2 col-12 lg:col-3">
									<label for="price">Code d'activité</label>
									<p-inputNumber id="price" [(ngModel)]="product.codeActivite"></p-inputNumber>
								</div>

							</div>
						</ng-template>

						<ng-template pTemplate="footer">
							<button pButton pRipple label="Annuler" icon="pi pi-times" class="p-button-text"
								(click)="hideDialog()"></button>
							<button pButton pRipple label="Ajouter" icon="pi pi-check" class="p-button-text"
								(click)="saveProduct(false)"></button>
							<button pButton pRipple label="Ajouter et fermer" icon="pi pi-check" class="p-button-text"
								(click)="saveProduct(true)"></button>
						</ng-template>
					</p-dialog>

				</p-tabPanel>
			</p-tabView>
		</p-card>
	</div>


</div>